import { useSelector } from 'core/common/hooks';
import { getIsTestingEnv } from 'core/common/store';

export const useEnvironment = () => {
  const isTesting = useSelector(getIsTestingEnv);

  return { isTesting };
};
